import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';

export const CREDIT_CARD = {
  visa: assetSource(ASSET_KEY.VISA),
  mastercard: assetSource(ASSET_KEY.MASTERCARD),
  amex: assetSource(ASSET_KEY.AMEX),
};

